import { SVGProps } from 'react';

export const IconRatingEmojiNegative = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 56 56'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g>
      <path
        d='M28 49c11.598 0 21-9.402 21-21S39.598 7 28 7 7 16.402 7 28s9.402 21 21 21Z'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M21.5 26a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM34.5 26a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z'
        fill='currentColor'
      />
      <path
        d='M22.167 35.583a8.167 8.167 0 0 1 11.667 0'
        stroke='currentColor'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);
